import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BirthRecordForm } from '../components';

const AddRecordPage = () => {
  const location = useLocation();
  const [key, setKey] = useState(0);

  // Force form to remount when navigating to this page
  useEffect(() => {
    setKey(prev => prev + 1);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BirthRecordForm key={key} />
      </div>
    </div>
  );
};

export default AddRecordPage;
